
const TestMappingSkeleton = () => {
  return (
    <div className="w-full animate-pulse">
      <div className="overflow-x-auto rounded-xl border border-gray-100 shadow-sm">
        <table className="w-full border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5]">
          <thead className="bg-[#F5F5F5]">
            <tr>
              <th className="p-3 w-[40%]"><div className="h-4 bg-gray-200 rounded w-1/2"></div></th>
              <th className="p-3 w-[20%]"><div className="h-4 bg-gray-200 rounded w-1/2"></div></th>
              <th className="p-3 w-[20%]"><div className="h-4 bg-gray-200 rounded w-1/2"></div></th>
              <th className="p-3 w-[10%]"><div className="h-4 bg-gray-200 rounded w-1/2"></div></th>
              <th className="p-3 w-[10%]"><div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div></th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {[...Array(8)].map((_, i) => (
              <tr key={i}>
                <td className="p-4 border-b border-gray-50">
                  <div className="h-4 bg-gray-100 rounded w-3/4"></div>
                </td>
                <td className="p-4 border-b border-gray-50">
                  <div className="h-8 bg-gray-50 rounded w-24"></div>
                </td>
                <td className="p-4 border-b border-gray-50">
                  <div className="h-8 bg-gray-50 rounded w-24"></div>
                </td>
                <td className="p-4 border-b border-gray-50">
                  <div className="h-8 bg-gray-50 rounded w-24"></div>
                </td>
                <td className="p-4 border-b border-gray-50 text-center">
                  <div className="h-8 bg-gray-100 rounded-full w-14 mx-auto"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TestMappingSkeleton;
